import { render, staticRenderFns } from "./SrnMatchCurrentStudent.vue?vue&type=template&id=52ecb42b&scoped=true&"
import script from "./SrnMatchCurrentStudent.vue?vue&type=script&lang=js&"
export * from "./SrnMatchCurrentStudent.vue?vue&type=script&lang=js&"
import style0 from "./SrnMatchCurrentStudent.vue?vue&type=style&index=0&id=52ecb42b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ecb42b",
  null
  
)

export default component.exports